import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useLocation } from 'react-router-dom'//React route//GifLoader
import { Typography } from '@mui/material'//Se importan elementos de la librería material-ui
import Parser from 'html-react-parser';
import { useTranslation } from 'react-i18next';

import { fileActions, workflowActions, userActions, addTitleLegoCurrent } from '../../store/actions'//Acciones para redux
import {
    CustomAlertMaterial,
    CustomLoadingOverlay,
    GenericContainer, GenericContainerForm,
    FormDynamic,
    ToastNotification,
    CustomAlertDialog,
} from '../../components'
import { coreFunctions } from '../../utils'//funciones del nucleo


export default function RecoverPasswordComponentLego(props) {
    const location = useLocation()
    // const localStyles = useStyles()
    const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader    
    const [stateActual, setStateActual] = useState('')
    const navigate = useNavigate()//Módulo "History" de react router

    //Estados de componente
    const [titleText, setTitleText] = useState('')
    const [textDescription, setDescription] = useState('')
    const [performLogout, setPerformLogout] = useState(0)
    const [allowCancelFlow, setAllowCancelFlow] = useState(0)
    const [goToDashboard, setGoToDashboard] = useState(0)
    const [iconRefValue, setIconRefValue] = useState('')
    const [cancelAction, setCancelAction] = useState(false)
    const [continueAction, setContinueAction] = useState(false)
    const [timerSeconds, setTimerSeconds] = useState(20)
    const [activeFileInfo, setActiveFileInfo] = useState(false)
    const [fileId, setFileId] = useState(0)
    const [activaContinueButton, setActivaContinueButton] = useState(0)
    const [activeCargaInicial, setActiveCargaInicial] = useState(false)
    const [showAlertMaterial, setShowAlertMaterial] = useState(false)
    const [statusFileInfo, setStatusFileInfo] = useState("")
    const [cuestionaryMetadata, setCuestionaryMetadata] = useState([])
    const [newCuestionaryMetadata, setNewCuestionaryMetadata] = useState([]);
    const { t } = useTranslation();

    //Redux hooks
    const auth = useSelector(state => state.Authentication)
    const changePassword = useSelector(state => state.RecoverChangePassword)
    const file = useSelector(state => state.FileInfo)
    const cancelWF = useSelector(state => state.CancelWorkFlow)
    const continueWF = useSelector(state => state.ContinueWorkflow)
    const dispatch = useDispatch()

    //Promesa general Init
    useEffect(() => {
        dispatch(addTitleLegoCurrent(""))
        setFileId(location.state.folioId)
        setStateActual(location.state.Name)
        let fileId = location.state.folioId
        dispatch(fileActions.GetFileInfo(fileId))
        setActiveCargaInicial(true)

        let stateStage = location.state.stage.Stage
        console.log('stateStage', stateStage)
        if (stateStage != undefined && stateStage != null) {
            // let title = stateStage.Properties.find(element => element.Name == "TitleData")
            // let description = stateStage.Properties.find(element => element.Name == "TextData")
            // let buttonData = stateStage.Properties.find(element => element.Name == "ButtonData")
            let performLogout = stateStage.Properties.find(element => element.Name == "PerformLogout")
            let allowCancelFlow = stateStage.Properties.find(element => element.Name == "AllowCancelFlow")
            let goToDashboard = stateStage.Properties.find(element => element.Name == "GoToDashboard")
            let iconRef = stateStage.Properties.find(element => element.Name == "IconRef")
            let ativateContButton = stateStage.Properties.find(element => element.Name == "ActivateContinueButton")

            let questionGroups = stateStage.QuestionGroups.find(element => element.Name.toUpperCase() === file.items.Stage.Name.toUpperCase());
            setCuestionaryMetadata(questionGroups.Questions)

            setStatusFileInfo(file.items.Status)
            setFileId(file.items.Id)
            // setTitleText(file.items.Stage.FlowState)
            setDescription(file.items.Stage.Description)
            dispatch(addTitleLegoCurrent(file.items.Stage.FlowState))
            setAllowCancelFlow(file.items.Stage.AllowCancel)

            setPerformLogout(performLogout?.Value)
            setGoToDashboard(goToDashboard?.Value)
            setIconRefValue(iconRef?.Value == "ic_gif_folder" ? iconRef?.Value?.toString()?.concat(".gif") : iconRef?.Value?.toString()?.concat(".jpg"))
            setActivaContinueButton(ativateContButton?.Value === undefined ? true : ativateContButton.Value)
            setTimerSeconds(ativateContButton?.Value == undefined || ativateContButton?.Value == false ? 25 : -1)
            setActiveCargaInicial(true)
        }
    }, [])

    useEffect(() => {
        if (timerSeconds == -4000000000000) {
            //Realiza la peticion
            setTimerSeconds(25)
            setActiveFileInfo(true)
            setActiveCargaInicial(true)
            // console.log("Realiza peticion nueva File Info: ")
            dispatch(fileActions.GetFileInfo(fileId))
        }
        // salir cuando lleguemos a 0
        if (!timerSeconds) return;

        // save intervalId para borrar el intervalo cuando el componente vuelve a renderizar
        const intervalId = setInterval(() => {
            setTimerSeconds(timerSeconds - 1);
        }, 1000);

        // clear interval al volver a renderizar para evitar pérdidas de memoria
        return () => clearInterval(intervalId);
    }, [timerSeconds]);


    //Obtener valores de persistencia de datos y mostrarlos en interfaz
    useEffect(() => {
        setLoadView(file.loading)
        //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
        if (file.items != undefined && activeCargaInicial) {
            let performLogout = file.items.Stage.Properties.find(element => element.Name == "PerformLogout")
            let goToDashboard = file.items.Stage.Properties.find(element => element.Name == "GoToDashboard")
            let iconRef = file.items.Stage.Properties.find(element => element.Name == "IconRef")
            let ativateContButton = file.items.Stage.Properties.find(element => element.Name == "ActivateContinueButton")

            let questionGroups = file.items.Stage.QuestionGroups.find(element => element.Name.toUpperCase() === file.items.Stage.Name.toUpperCase());
            setCuestionaryMetadata(questionGroups.Questions)

            setStatusFileInfo(file.items.Status)
            setFileId(file.items.Id)
            // setTitleText(file.items.Stage.FlowState)
            setDescription(file.items.Stage.Description)
            dispatch(addTitleLegoCurrent(file.items.Stage.FlowState))
            setAllowCancelFlow(file.items.Stage.AllowCancel)

            setPerformLogout(performLogout?.Value)
            setGoToDashboard(goToDashboard?.Value)
            setIconRefValue(iconRef?.Value == "ic_gif_folder" ? iconRef?.Value?.toString()?.concat(".gif") : iconRef?.Value?.toString()?.concat(".jpg"))
            setActivaContinueButton(ativateContButton?.Value === undefined ? true : ativateContButton.Value)
            setTimerSeconds(ativateContButton?.Value == undefined || ativateContButton?.Value == false ? 25 : -1)

            if (activeFileInfo && stateActual != file.items.Stage.Name) {
                if (goToDashboard == 1 || goToDashboard == "1") {
                    navigate('/SearchResultComponent')
                } else if (performLogout == 1) {
                    navigate('/auth/')
                } else {
                    let nextStage = file.items.Stage
                    let stageName = nextStage.Name
                    let stageId = nextStage.Id
                    let folioId = file.items.Id
                    let stage = file.items
                    let nextComponent = coreFunctions.GetLegoNext(stageName)
                    coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
                }
            }
        }
    }, [file])

    useEffect(() => {
        if (cancelWF.items != undefined && cancelAction) {
            if (goToDashboard == 1) {
            } else if (performLogout == 1) {
                navigate('/auth/')
            } else {
                navigate('/auth/')
            }
        }
    }, [cancelWF])

    useEffect(() => {
        setLoadView(continueWF.loading)
        if (continueWF.items != undefined && continueAction) {
            if (goToDashboard == 1 || goToDashboard == "1") {
                navigate('/main/SearchResultComponent')
            } else if (performLogout == 1) {
                navigate('/auth/')
            } else {
                let nextStage = continueWF.items.Stage
                let stageName = nextStage.Name
                let stageId = nextStage.Id
                let folioId = location.state.folioId
                let stage = continueWF.items

                let nextComponent = coreFunctions.GetLegoNext(stageName)
                coreFunctions.DoNextStage({ navigate, nextComponent, State: { stageName, stageId, stage, folioId } })
            }
        }
    }, [continueWF])


    let handleContinue = (data) => {
        if (data.Contraseñanueva != data.Repitetucontraseña) {
            ToastNotification({
                icon: "error",
                text: t("passwords_not_match"),
            });
            return null;
        }
        let dataRequest = {
            UserName: auth.items.UserLoginData.Username,
            NewPassword: data.Contraseñanueva
        }
        dispatch(userActions.RecoverChangePassword(dataRequest))
    }

    useEffect(() => {
        //Validar que la información haya sido recibida correctamente por el API
        setLoadView(changePassword.loading);
        if (changePassword.error != undefined) {
            alert(changePassword.error);
            setLoadView(false)
        } else {
            if (changePassword.items != undefined) {
                setContinueAction(true)
                let dataRequest = {
                    File_Id: fileId
                }
                dispatch(workflowActions.ContinueWorkflowAction(dataRequest))
            }
        }
    }, [changePassword]);

    let handleCancel = () => {
        setShowAlertMaterial(true)
    }

    let handleAlerDialog = (pos) => {
        switch (pos) {
            case 'left':
                setShowAlertMaterial(false)
                break;
            case 'right':
                setCancelAction(true)
                dispatch(workflowActions.CancelWorkFlow({ File_Id: file.items.Id }))
                break;
            default:
                break;
        }
        setShowAlertMaterial(false)
    }


    useEffect(() => {
        console.log('cuestionaryMetadata:::',cuestionaryMetadata)
        const nuevosDatos = cuestionaryMetadata.map(item => ({
            ...item,
            Id: item.Name.replace(/\s/g, ''), // Renombrar la propiedad "nombre" a "nuevoNombre"
            DataType: item.QuestionType || item?.DataType, // Renombrar la propiedad "nombre" a "nuevoNombre"
        }));
        setNewCuestionaryMetadata(nuevosDatos)
    }, [cuestionaryMetadata])


    //Comienza interfaz
    return (<GenericContainer>
        <Typography variant="h6"
            gutterBottom >{titleText}</Typography>
        <Typography variant="subtitle1" gutterBottom >
            <b>
                {t("password_recommendations")}
            </b>
        </Typography>
        <Typography variant="subtitle1" gutterBottom >
            {t("password_requirements")}
        </Typography>

        <GenericContainerForm>
            {newCuestionaryMetadata?.length > 0 ?
                <FormDynamic DataControls={newCuestionaryMetadata}
                    handleConfirm={handleContinue}
                    ConfirmButtonText={t("general_save")}
                // handleCancel={handleCancel} 
                />
                : null}

        </GenericContainerForm>

        {loadView ? <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} /> : null}
        <CustomAlertDialog
            open={showAlertMaterial}
            // closeAction={() => handleAlerDialog('left')}
            title={t("general_cancel")}
            textDescription={t("password_cancel_message")}
            textAcepted={t("general_accept")}
            textCancel={t("general_cancel")}
            aceptedAction={() => handleAlerDialog('left')}
            cancelAction={() => handleAlerDialog('left')}
        />
    </GenericContainer>
    )
}
